// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 203) return "static/chunks/e3762d72-ee78ba5b245f9ffa.js";
	if (chunkId === 921) return "static/chunks/921-2ab5d78326564af1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"cbafb3474b2d70cb","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"40389f2b3659d8e0","367":"70a867ce44e8d569","639":"792e0c65c102277d","748":"491bdbeb2e77476e"}[chunkId] + ".js";
};